export default "__VITE_ASSET__31293eed__"